import { useQuery } from "@tanstack/react-query";
import { getEmployeeByCode } from "src/redux/api/_hr.api";

export const useSearchEmployeeByCode = (employee_code: string) => {
  return useQuery({
    queryKey: ["hr-employee-by-code", employee_code],
    queryFn: () => getEmployeeByCode(employee_code),
    enabled: !!employee_code &&employee_code.trim().length >= 6, // only trigger after 6 chars
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });
};
